import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["children", "parentOffset", "viewportHeight", "viewportWidth", "isIframe", "iframeHeight", "disableTopOffset", "textAlign"];
var __jsx = React.createElement;
import React from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { height, space, width, layout } from 'styled-system';
import ExitIcon from 'shared/assets/exit-icon';
export var ModalExitIcon = function ModalExitIcon(props) {
  return __jsx(ModalExitIconStyles, _extends({
    "aria-label": "Close"
  }, props, {
    autoFocus: true
  }), __jsx(ExitIcon, null));
};
var ModalExitIconStyles = styled.button.withConfig({
  displayName: "v2-container__ModalExitIconStyles",
  componentId: "sc-162m085-0"
})(["appearance:none;border:none;padding:0;background-color:transparent;cursor:pointer;width:27px;position:absolute;z-index:10;top:24px;right:24px;fill:var(--dcm-modal-close-color,", ");"], function (_ref) {
  var _theme$colors;
  var theme = _ref.theme;
  return theme === null || theme === void 0 || (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.grey[45];
});
var Modal = styled.div.attrs(function (_ref2) {
  var top = _ref2.top;
  return {
    tabIndex: '-1',
    style: {
      top: top
    }
  };
}).withConfig({
  displayName: "v2-container__Modal",
  componentId: "sc-162m085-1"
})(["position:relative;padding:31px 47px 45px 47px;background-color:var(--dcm-modal-bg,", ");border-radius:var(--dcm-modal-border-radius,28px);box-shadow:var(--dcm-modal-shadow,0 5px 15px 0 rgba(0,0,0,0.14));min-height:78px;margin:0 auto;text-align:", ";top:50%;transform:translateY(-50%);", " ", " ", " ", " ", " ", "{width:", ";}"], function (_ref3) {
  var _theme$colors2;
  var theme = _ref3.theme;
  return theme === null || theme === void 0 || (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.white;
}, function (_ref4) {
  var textAlign = _ref4.textAlign;
  return textAlign;
}, function (_ref5) {
  var isIframe = _ref5.isIframe,
    _ref5$additionalMobil = _ref5.additionalMobileCSS,
    additionalMobileCSS = _ref5$additionalMobil === void 0 ? '' : _ref5$additionalMobil;
  return isIframe && css(["position:absolute;left:50%;transform:translate(-50%,-50%);", "{transform:translate(-50%,0);", "}"], function (_ref6) {
    var _theme$breakpoints;
    var theme = _ref6.theme;
    return theme === null || theme === void 0 || (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.down('sm');
  }, additionalMobileCSS);
}, space, width, height, layout, function (_ref7) {
  var _theme$breakpoints2;
  var theme = _ref7.theme;
  return theme === null || theme === void 0 || (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.down('xs');
}, function (_ref8) {
  var viewportWidth = _ref8.viewportWidth;
  return viewportWidth ? "".concat(viewportWidth, "px") : "calc(100vw - 16px)";
});

/**
 * @type {React.FC<
 * {
 *  ref?: any;
 *  children?: React.ReactNode;
 *  parentOffset?: number | string;
 *  viewportHeight?: number | string;
 *  viewportWidth?: number | string;
 *  iframeHeight?: number | string | null;
 *  isIframe?: boolean;
 *  additionalMobileCSS?: string;
 *  onRequestClose?: () => void;
 *  textAlign?: string;
 * }
 * & import("styled-system").SpaceProps
 * & import("styled-system").LayoutProps
 * >}
 */
export var ModalContainer = /*#__PURE__*/React.forwardRef(function (_ref9, ref) {
  var children = _ref9.children,
    _ref9$parentOffset = _ref9.parentOffset,
    parentOffset = _ref9$parentOffset === void 0 ? null : _ref9$parentOffset,
    _ref9$viewportHeight = _ref9.viewportHeight,
    viewportHeight = _ref9$viewportHeight === void 0 ? null : _ref9$viewportHeight,
    _ref9$viewportWidth = _ref9.viewportWidth,
    viewportWidth = _ref9$viewportWidth === void 0 ? null : _ref9$viewportWidth,
    _ref9$isIframe = _ref9.isIframe,
    isIframe = _ref9$isIframe === void 0 ? false : _ref9$isIframe,
    _ref9$iframeHeight = _ref9.iframeHeight,
    iframeHeight = _ref9$iframeHeight === void 0 ? null : _ref9$iframeHeight,
    _ref9$disableTopOffse = _ref9.disableTopOffset,
    disableTopOffset = _ref9$disableTopOffse === void 0 ? false : _ref9$disableTopOffse,
    _ref9$textAlign = _ref9.textAlign,
    textAlign = _ref9$textAlign === void 0 ? 'center' : _ref9$textAlign,
    props = _objectWithoutProperties(_ref9, _excluded);
  var lower = viewportHeight / 2;
  var upper = iframeHeight - lower;
  var desktopOffset = isIframe ? _.clamp(parentOffset + lower, lower, upper) : null;
  var mobileOffset = isIframe ? _.clamp(parentOffset, 0, upper) : null;
  var isMobile = viewportWidth <= 900;
  var top = isMobile ? mobileOffset : desktopOffset;
  return __jsx(Modal, _extends({
    ref: ref,
    top: disableTopOffset ? 0 : top,
    isIframe: isIframe,
    "data-cy": "modal-container",
    "data-testid": "modal-container",
    textAlign: textAlign
  }, props), children);
});
export var ModalFooter = styled.div.withConfig({
  displayName: "v2-container__ModalFooter",
  componentId: "sc-162m085-2"
})(["display:flex;justify-content:center;align-items:center;height:50px;width:100%;background-color:", ";border-radius:0 0 var(--dcm-modal-border-radius,28px) var(--dcm-modal-border-radius,28px);"], function (_ref10) {
  var _ref10$includeBackgro = _ref10.includeBackgroundColor,
    includeBackgroundColor = _ref10$includeBackgro === void 0 ? true : _ref10$includeBackgro;
  return includeBackgroundColor ? "var(--dcm-modal-footer-bg, #f3f6f8)" : "inherit";
});